import React from "react";
// import img1 from "../assets/images/sidom/fotos/100porcierntocloud.png";
// import img2 from "../assets/images/sidom/fotos/integracion.png";
// import img3 from "../assets/images/sidom/fotos/reduccioncostos.png";
// import img4 from "../assets/images/sidom/fotos/seguimientoreportes.png";

export default function Beneficios(data) {
  // Validación para evitar errores si data o data.data es undefined
  const beneficiosApi =
    Array.isArray(data?.data) && data.data[0]?.beneficio
      ? data.data[0].beneficio
      : [];
  // const beneficios = [
  //   {
  //     icon: img1,
  //     title: "100% Cloud y Usuarios ilimitados",
  //     description:
  //       "Acceda a su información  desde cualquier lugar y colabore sin límites con SIDOM. Nuestra plataforma en la nube garantiza flexibilidad y eficiencia para su equipo.",
  //   },
  //   {
  //     icon: img2,
  //     title: "Seguimiento automático y reportes en tiempo real",
  //     description:
  //       "Tome el control total de sus operaciones automatizando tareas claves. Potencie la toma de decisiones con el análisis de datos a través de reportes. Visibilidad de principio a fin.",
  //   },
  //   {
  //     icon: img3,
  //     title: "Integraciones Comex y ERP",
  //     description:
  //       "Optimice sus operaciones con nuestras integraciones. Conecte y gestione todos sus procesos en una sola plataforma eficiente.",
  //   },
  //   {
  //     icon: img4,
  //     title: "30% de Reducción de Costos Operativos",
  //     description:
  //       "Nuestras soluciones de automatización liberan tiempo y recursos para reasignar a tareas estratégicas. El retorno de Inversión se percibe desde la implementación.",
  //   },
  // ];
  const urlApi = process.env.REACT_APP_STRAPI_URL;
  return (
    <div
      data-testid="beneficios-section"
      className="mt-[70px] md:mt-[100px] lg:mt-[90px] "
    >
      <div className="container  dark:text-sidom-dark px-1 bg-sidom-light  dark:bg-sidom-blue">
        <h1 className="text-sidom-orange text-3xl md:text-[40px] lg:text-[45px]  leading-[1.3] px-2 md:px-0 lg:px-0 font-extrabold text-left mb-[60px]">
          Beneficios
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 mb-[100px]  mt-5 gap-10">
          {beneficiosApi.map((beneficio, index) => (
            <div
              key={index}
              className="bg-sidom-blue p-4 dark:bg-sidom-orange h-full rounded-3xl leading-[1.3] shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex flex-col h-full gap-3 p-4">
                <div className="  rounded-full p-2">
                  <div className="   flex justify-center items-center rounded-full  w-12 h-12">
                    <img
                      src={`${urlApi}${beneficio?.logo?.formats?.thumbnail?.url}`}
                      alt={beneficio.titulo}
                      className="w-12 h-12 object-contain"
                    />
                  </div>
                </div>
                <div className="flex flex-col justify-start w-[80%] items-start   ">
                  <h1 className=" text-3xl  text-sidom-light font-black ">
                    {beneficio?.titulo}
                  </h1>
                </div>
                <div>
                  <p className=" text-sidom-light   ">
                    {beneficio?.descripcion}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
